import { Plugin } from "chart.js";

export function createChartAreaImagePlugin(imageUrl: string, alpha = 0.25): Plugin[] {
    if (!imageUrl) return [];

    const image = new Image();
    let failed = false;
    image.onerror = () => { failed = true; };
    image.src = imageUrl;

    return [{
        id: 'customCanvasBackgroundImage',
        beforeDraw: (chart) => {
            if (!chart || !chart.ctx || failed) return;

            if (!image.complete) {
                image.onload = () => chart.draw();
                return;
            }

            // image.complete is also true for broken images (load failed); the
            // bitmap only exists if naturalWidth/Height > 0. Skipping here
            // avoids "HTMLImageElement is in the 'broken' state" from drawImage.
            if (!image.naturalWidth || !image.naturalHeight) return;

            const ctx = chart.ctx;
            const { top, left, width, height } = chart.chartArea;
            const prevAlpha = ctx.globalAlpha;
            ctx.globalAlpha = alpha;
            ctx.drawImage(image, left, top, width, height);
            ctx.globalAlpha = prevAlpha;
        }
    }];
};

